import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./about-md.scss";
import Signature from "./azca hamza asif signature png white.png";
import MDImage from "../../../assets/img/team/hamza.jpg";
import useFetch from "../../../Hooks/useFetch";

export default function AboutMD() {
  const { data } = useFetch();
  const myField = data?.items.find((item, index) => {
    if (item.sys.id === "1VpU31BISPlAMHez6ODkDz") {
      return item;
    }
  });

  // console.log(myField?.fields)
  return (
    <div id="about-md">
      <Container>
        <Row>
          <Col lg={7} className="detail-div">
            <h2>
              {myField?.fields.mdName} <br />
              <span>({myField?.fields.mdPosition})</span>
            </h2>

            <p>{myField?.fields.mdDetails}</p>
            <div className="d-flex justify-content-center">
              <img
                src={myField?.fields.mdSignature.fields.file.url}
                alt="signature"
                style={{
                  height: "27vh",
                  marginLeft: "5rem",
                  marginTop: "2rem",
                }}
              />
            </div>
          </Col>
          <Col lg={5}>
            <Image
              src={myField?.fields.mdProfile.fields.file.url}
              roundedCircle
              className="md-image-style"
              style={{}}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
